import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../../AppTheme";

export default function AddIcon(props) {
  const color = props.fillColor || AppTheme.almostBlack

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M12.4801 7.15378C12.2676 7.15352 12.0637 7.23782 11.9134 7.3881C11.7631 7.53837 11.6788 7.74227 11.6791 7.95479L11.6802 11.6804L7.95463 11.6793C7.51224 11.6793 7.15362 12.0379 7.15362 12.4803C7.15362 12.9227 7.51224 13.2813 7.95463 13.2813L11.6802 13.2802L11.6791 17.0058C11.6791 17.4481 12.0377 17.8068 12.4801 17.8068C12.9225 17.8068 13.2811 17.4481 13.2811 17.0058L13.28 13.2802L17.0056 13.2813C17.2918 13.2813 17.5562 13.1286 17.6993 12.8808C17.8424 12.633 17.8424 12.3276 17.6993 12.0798C17.5562 11.8319 17.2918 11.6793 17.0056 11.6793L13.28 11.6804L13.2811 7.95479C13.2814 7.74227 13.1971 7.53837 13.0468 7.3881C12.8965 7.23782 12.6926 7.15352 12.4801 7.15378Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.88013 12.4802C2.88013 7.17832 7.17819 2.88025 12.4801 2.88025C17.7799 2.88554 22.0748 7.18051 22.0801 12.4802C22.0801 17.7822 17.7821 22.0802 12.4801 22.0802C7.17819 22.0802 2.88013 17.7822 2.88013 12.4802ZM4.48005 12.4802C4.48005 16.8984 8.06177 20.4802 12.48 20.4802C14.6018 20.4802 16.6366 19.6373 18.1369 18.137C19.6372 16.6367 20.48 14.6019 20.48 12.4802C20.48 8.06189 16.8983 4.48017 12.48 4.48017C8.06177 4.48017 4.48005 8.06189 4.48005 12.4802Z"
          fill={color}
        />
      </Svg>
    </TouchableOpacity>
  );
}
